import React from 'react';

export const AboutFounderHeader: React.FC = () => {
	return (
		<h1 className='self-start text-5xl leading-none text-neutral-800 max-md:max-w-full max-md:text-4xl md:px-20 px-10'>
			<strong>Founder's</strong> note.
		</h1>
	);
};
